<script>
import { Doughnut } from "vue-chartjs";
export default {
  extends: Doughnut,

  data() {
    return {
      chart_options: {
        legend: {
          position: "bottom",
        },
        responsive: true,
        maintainAspectRatio: false,
      },
      datas: {},
    };
  },
  mounted() {
    if (this.static_chart_data.labels.length > 0) {
      this.drawGraph(this.static_chart_data);
    }
  },
  methods: {
    drawGraph(datas_graph) {
      console.log(datas_graph, this.print);
      let componentGraph = this;
      setTimeout(function () {
        componentGraph.renderChart(datas_graph, componentGraph.chart_options);
      }, 1000);
    },
  },
  props: {
    print: {
      default: false,
    },
    static_chart_data: {
      type: Object,
      required: false,
      default() {
        return {
          labels: [],
          datasets: [],
        };
      },
    },
  },
};
</script>
